export enum UserRole {
  user,
  admin,
  super_user = 9
}